import { initContract } from '@ts-rest/core';
export const USER_FILE_STATUS = {
    UPLOADING: 'uploading',
    EMBEDDING: 'embedding',
    COMPLETED: 'completed',
    ERROR: 'error',
};
export const COLORS = [
    'yellow',
    'blue',
    'magenta',
    'green',
    'purple',
    'orange',
    'red',
    'tan',
];
const c = initContract();
export const sourcesContract = c.router({
    deleteSource: {
        method: 'DELETE',
        path: '/sources/:id',
        summary: 'Delete a source',
        responses: {
            200: c.type(),
        },
    },
    getKnowledgeGroups: {
        method: 'GET',
        path: '/sources/knowledge-groups',
        summary: 'Get all knowledge groups',
        responses: {
            200: c.type(),
        },
    },
    getSources: {
        method: 'GET',
        path: '/sources',
        summary: 'Get all sources',
        responses: {
            200: c.type(),
        },
    },
    getPresignedUrls: {
        method: 'POST',
        path: '/sources/presigned-urls',
        summary: 'Get presigned URLs for file uploads',
        body: c.type(),
        responses: {
            200: c.type(),
            400: c.type(),
            401: c.type(),
        },
    },
    registerFiles: {
        method: 'POST',
        path: '/sources/register',
        summary: 'Register uploaded files in database',
        body: c.type(),
        responses: {
            200: c.type(),
        },
    },
});
//# sourceMappingURL=sources.js.map